<template>
  <vs-popup class="holamundo" title="Transfer Antrian" :active.sync="popupTransfer">
    <div class="vx-row">
      <div class="flex flex-col w-full justify-center p-5">
        <div class="w-full text-center font-medium text-xl">{{counter.name}}</div>
        <div class="w-full text-center flex flex-col py-5">
          <span class="text-6xl text-primary">{{queue.ticket_code}}</span>
          <span class="text-lg">{{queue.customer_name}}</span>
        </div>
        <div class="w-full text-center text-base">
          <div class="flex flex-col items-center mb-3">
            <div class="vx-col w-2/3">
              <v-select
                placeholder="Transfer ke Loket"
                :options="options"
                :value="counterValue"
                @input="setSelectedCounter"
              />
            </div>
            <div class="vx-col flex justify-center w-full text-center py-5">
              <vs-button
                @click="send"
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-send"
              >
                <span v-if="true">Transfer</span>
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </vs-popup>
</template>
<script>
import vSelect from "vue-select";

export default {
  props: {
    bus: {
      type: Object,
      required: true
    },
    counter: {
      required: true
    }
  },
  data() {
    return {
      popupTransfer: false,
      queue: {},
      options: [],
      counterValue: null
    };
  },
  components: {
    vSelect
  },
  mounted() {
    this.bus.$on("openTransfer", e => {
      this.queue = e;
      this.popupTransfer = true;
    });

    this.bus.$on("counterList", e => {
      this.options = [];
      e.map(item => {
        if (item.on_service == null && this.counter.id != item.counter_id) {
          this.options.push({
            value: item.counter_id,
            label: item.counter_name
          });
        }
      });
    });
  },
  methods: {
    send() {
      this.$http
        .post(`/app/secure/counter-process/transfer`, {
          queue_id: this.queue.queue_id,
          counter_id: this.counterValue.value
        })
        .then(() => {
          this.popupTransfer = false;
          this.bus.$emit("reloadQueue");
        })
        .catch(e => {
          this.parseError(e);
        });
    },
    setSelectedCounter(e) {
      this.counterValue = e;
    }
  }
};
</script>